import React, { useEffect, useRef, useState } from "react";
// eslint-disable-next-line import/no-unresolved
import GettingStartedContent from "@regional/templates/GettingStarted";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import GettingStartedSlider from "./GettingStartedSlider";
import DialogPopup from "../../../../components/DialogPopup";

const dialogDefinitions = [
  {
    id: "getStartedPref",
    content: <GettingStartedContent />,
    title: "Getting started",
    showDoNotShowMeThisAgain: true,
  },
  {
    id: "announcements",
    content: null,
    title: "Announcements",
    showDoNotShowMeThisAgain: true,
  },
];

async function importConfigModules(_dialogs) {
  // eslint-disable-next-line import/no-unresolved
  await import("@regional/templates/GettingStarted/config")
    .then((config) => {
      const { files = [], showDoNotShowMeThisAgain } =
        config.default.announcements || {};
      const promises = files.map((file) =>
        import(`@regional/templates/GettingStarted/${file}`).then(
          (content) => ({
            content: content.default(),
            showDoNotShowMeThisAgain,
          })
        )
      );
      return Promise.all(promises);
    })
    .then((files) => {
      const dialog = _dialogs.find((d) => d.id === "announcements");
      const steps = files.map((file, index) => ({
        id: index,
        description: file.content,
      }));
      if (files.length === 1) dialog.content = files[0].content;
      if (files.length > 1)
        dialog.content = <GettingStartedSlider steps={steps} />;
      dialog.showDoNotShowMeThisAgain = files[0]?.showDoNotShowMeThisAgain;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Error loading file:", error);
      return null;
    });
}

function findNextEligibleDialogIndex(currentIndex, dialogsArray) {
  const nextIndex = currentIndex + 1;
  for (let i = nextIndex; i < dialogsArray.length; i += 1) {
    const { id, content } = dialogsArray[i];
    // eslint-disable-next-line no-continue
    if (!id || !content) continue;
    const hideDialog = localStorage.getItem(id);
    if (!hideDialog) return i;
  }
  return -1;
}

function GettingStartedDialog() {
  const dialogTimerRef = useRef(null);
  const [currentDialogIndex, setCurrentDialogIndex] = useState(-1);

  const handleChange = (e) => {
    const mainContent = dialogDefinitions[currentDialogIndex];
    if (!mainContent.id) return;
    if (e.target.checked) localStorage.setItem(mainContent.id, true);
    else localStorage.removeItem(mainContent.id);
  };
  function showNextDialog() {
    setCurrentDialogIndex((prevIndex) =>
      findNextEligibleDialogIndex(prevIndex, dialogDefinitions)
    );
  }

  const onCloseDialog = () => {
    const idx = currentDialogIndex;
    setCurrentDialogIndex(-1);
    dialogTimerRef.current = setTimeout(() => {
      setCurrentDialogIndex(
        findNextEligibleDialogIndex(idx, dialogDefinitions)
      );
    }, 250);
  };

  useEffect(() => {
    importConfigModules(dialogDefinitions).finally(() => {
      showNextDialog();
    });
    return () => {
      if (dialogTimerRef.current) clearTimeout(dialogTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDialogOpen = currentDialogIndex > -1;
  let dialogTitle = "";
  let showDoNotShowMeThisAgain = false;
  let dialogContent = null;

  if (isDialogOpen) {
    dialogTitle = dialogDefinitions[currentDialogIndex].title;
    showDoNotShowMeThisAgain =
      dialogDefinitions[currentDialogIndex].showDoNotShowMeThisAgain;
    dialogContent = (
      <Box
        sx={{
          px: "1em",
          "& .MuiTypography-root": {
            mb: "0.8em",
            fontSize: "0.88rem",
          },
          "& .buttonContainer": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& .MuiFormControlLabel-root": {
            display: "flex",
            alignItems: "end",
          },
        }}
      >
        {dialogDefinitions[currentDialogIndex].content}
        {showDoNotShowMeThisAgain && (
          <FormControlLabel
            label="Do not show me this again"
            control={<Checkbox onChange={handleChange} />}
          />
        )}
        <Box className="buttonContainer">
          <Button variant="contained" onClick={onCloseDialog}>
            Continue
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <DialogPopup
      title={dialogTitle}
      onCancel={onCloseDialog}
      openPopup={isDialogOpen}
      content={dialogContent}
      maxWidth="md"
    />
  );
}
export default GettingStartedDialog;
